import { Component, OnInit, OnDestroy } from '@angular/core';

declare var $: any;

import { SettingsService } from "../../services/shared/settings.service";
import { DnaService } from "../../services/shared/dna.service";
import { ISelectedDna } from "../../shared/components/dnaselector/dnaselector.component";
import { DomSanitizer } from '@angular/platform-browser';
import { DnaClientBase } from "../../models/dna/dna.client.model";
import { Router } from "@angular/router";
import { ThemesService } from '../../services/shared/themes.service';

@Component({
  selector: 'app-offsidebar',
  templateUrl: './offsidebar.component.html',
  styleUrls: ['./offsidebar.component.scss']
})
export class OffsidebarComponent implements OnInit, OnDestroy {
  public currentTheme: any;
  public selectedLanguage: string;
  public clickEvent = 'click.offsidebar';
  public $doc: any = null;
  public selectedDna: ISelectedDna;
  public defaultDna: DnaClientBase;

  public base64LogoImage: any;

  constructor(public settings: SettingsService,
    public themes: ThemesService,
    private dnaService: DnaService,
    private domSanitizer: DomSanitizer,
    private router: Router) {
    this.currentTheme = themes.getDefaultTheme();
    this.selectedLanguage = 'en';
  }

  public ngOnInit() {
    this.anyClickClose();
    this.dnaService.defaultDnaObservable.subscribe((res) => {
      if (!res || res.dnaId <= 0) {
        this.settings.layout.offsidebarOpen = true;
        return;
      }

      this.defaultDna = res;
      if (this.defaultDna.dnaLogoBase64) {
        this.base64LogoImage =
          this.domSanitizer.bypassSecurityTrustResourceUrl('data:image/jpg;base64,' +
            this.defaultDna.dnaLogoBase64);
      }
    });
  }

  public setTheme() {
    this.themes.setTheme(this.currentTheme);
  }

  public getLangs() {
    return [{ code: 'en', text: 'English' }];
  }

  public anyClickClose() {
    this.$doc = $(document).on(this.clickEvent,
      (e) => {
        if (!$(e.target).parents('.offsidebar').length) {
          if (this.defaultDna && this.defaultDna.dnaId > 0) {
            this.closeSidebar(e);
          }
        }
      });
  }

  public setDnaAsDefaultEvent(e: any) {
    this.dnaService.changeDefaultDnaOfUser(this.selectedDna);
    this.closeSidebar(e);
  }

  public closeSidebar(e: any) {
    if (this.defaultDna && this.defaultDna.dnaId > 0) {
      this.settings.layout.offsidebarOpen = false;
    }
  }

  public ngOnDestroy() {
    if (this.$doc) {
      this.$doc.off(this.clickEvent);
    }
  }

  public defaultDnaChanged(e: any) {
    this.selectedDna = e;
  }

  public onDnaSettingsClick() {
    this.router.navigateByUrl('/dna/dnamanager');
  }

  public onDnaConfigurationClick() {
    this.router.navigateByUrl('/dna/modifydna');
  }
}
